
import { Directive, HostListener } from '@angular/core';


@Directive({
    selector: '[track-focus]',
    exportAs: 'trackFocus'
})
export class TrackFocusDirective {
  // @HostBinding('class.my-focused-element') isFocused: boolean;
  isFocused: boolean;
  constructor() {}

  @HostListener('focus', ['$event']) onFocus(e) {
    this.isFocused = true;
  }
  @HostListener('blur', ['$event']) onblur(e) {
    this.isFocused = false;
  }
}